export default __webpack_public_path__ + "static/winter33-36c29e6ff81a0fab6f663af14c989361.webp";